import transactionBillingService from '../../../services/notisphere/transactionBilling'
import { noti_Billing_Headers, AG_GridCustomizedTableHeaders_Key } from '../../../misc/tableHeaders'
import moment from 'moment-timezone'
export default {
    data() {
        const today = new Date()
        const billing_from_date = new Date(today.getFullYear(), today.getMonth(), 1)
        const billing_to_date = new Date(today.getFullYear(), today.getMonth() + 1, 0)
        return {
            columnDefs: null,
            gridOptions: {
                onFilterChanged: this.onFilterChanged,
                onSortChanged: this.onSortChanged,
            },
            searchQuery: { pageNumber: 1, pageSize: 50, sort: null, colId: null },
            total: 0,
            items: [],
            gridApi: null,
            columnApi: null,
            search: {
                name: null,
                recalls_opened: null,
                affected_providers: null,
                affected_locations: null,
                notification_rounds: null,
                affected_locations_notifications: null,
                affected_locations_acknowledgements: null,
                affected_locations_completed: null,
            },
            table_Connection_Data: this.$store.state.CustomizedHeaders.filter(s => s.userId == this.$store.state.user.id)[0],
            billing_from_date: billing_from_date,
            billing_to_date: billing_to_date,
            lastGridParams: null,
            billing_filter_val: 'current_month',
        }
    },
    beforeMount() {
        this.columnDefs = noti_Billing_Headers
    },
    created() {
        this.rowModelType = 'serverSide'
    },
    methods: {
        saveState(params) {
            // Get current header fields from noti_Billing_Headers
            const currentHeaderFields = noti_Billing_Headers.map(col => col.field)
            // Get column state from params
            const columnState = params.columnApi.getColumnState()
            const savedHeaderFields = columnState ? columnState.map(col => col.colId) : []
            // If fields do not match (new/removed columns), reset saved state
            const isSame = currentHeaderFields.length === savedHeaderFields.length && currentHeaderFields.every((f, i) => f === savedHeaderFields[i])
            if (!isSame) {
                this.table_Connection_Data.Notisphere_Login.Billing_Headers = undefined
            } else {
                this.table_Connection_Data.Notisphere_Login.Billing_Headers = columnState
            }
            localStorage.setItem(AG_GridCustomizedTableHeaders_Key, JSON.stringify(this.$store.state.CustomizedHeaders))
        },
        setFilterModel(params) {
            const tableState = JSON.parse(localStorage.getItem(AG_GridCustomizedTableHeaders_Key))?.filter(s => s.userId == this.$store.state.user.id)[0]
            const filterModel = tableState?.Notisphere_Login?.Billing_Filters || {}
            params.api.setFilterModel(filterModel)
        },
        applyState(params) {
            // Get saved state
            var tableState = JSON.parse(localStorage.getItem(AG_GridCustomizedTableHeaders_Key))?.filter(s => s.userId == this.$store.state.user.id)[0]
            var columnState = tableState?.Notisphere_Login?.Billing_Headers
            // Get current header fields from noti_Billing_Headers
            const currentHeaderFields = noti_Billing_Headers.map(col => col.field)
            // Get saved header fields from columnState
            const savedHeaderFields = columnState ? columnState.map(col => col.colId) : []
            // If saved state exists, but fields do not match (new/removed columns), clear saved state
            const isSame = currentHeaderFields.length === savedHeaderFields.length && currentHeaderFields.every((f, i) => f === savedHeaderFields[i])
            if (columnState && !isSame) {
                // Remove saved state for this user
                this.table_Connection_Data.Notisphere_Login.Billing_Headers = undefined
                localStorage.setItem(AG_GridCustomizedTableHeaders_Key, JSON.stringify(this.$store.state.CustomizedHeaders))
                columnState = undefined
            }
            if (columnState) {
                params.columnApi.applyColumnState({ state: columnState, applyOrder: true })
            }
        },
        onFilterChanged(event) {
            const filterModel = event.api.getFilterModel()
            this.table_Connection_Data.Notisphere_Login.Billing_Filters = filterModel
            localStorage.setItem(AG_GridCustomizedTableHeaders_Key, JSON.stringify(this.$store.state.CustomizedHeaders))
            this.fetchData(event)
        },
        onSortChanged(event) {
            this.saveState(event)
            this.fetchData(event)
        },
        onCellClicked(params) {
            if (params.column.colId === 'actions') {
                if (params.event.target.dataset.action === 'view') {
                    this.viewRecall(params.data)
                }
                return
            }else{
                this.viewRecall(params.data)
            }
        },
        ViewClick(val) {
            this.viewModalKey += 1
            this.$nextTick(() => {
                this.$refs.viewModal.forceRerenderInsert(val)
            })
        },
        btnApplyDateFilterClick() {
            if (!this.isOneYearDateRangeValid()) {
                this._showToast('Please select a date range within a one-year period.', { variant: 'danger' })
                return
            }
            if (this.billing_from_date && this.billing_to_date) {
                const fromDate = new Date(this.billing_from_date)
                const toDate = new Date(this.billing_to_date)
                if (toDate >= fromDate && this.lastGridParams) {
                    this.fetchData(this.lastGridParams)
                }
                else{
                    this._showToast('To Date should be greater than From Date', { variant: 'danger' })
                }
            }
            else{
                this._showToast('Please select both From and To dates to apply the filter', { variant: 'danger' })
            }
        },
        fetchData(params) {
            if (!params || !params.api || !params.columnApi) {
                return
            }
            this.lastGridParams = params
            let that = this
            this.applyState(params)
            this.setFilterModel(params)
            that.gridApi = params.api
            that.columnApi = params.columnApi
            localStorage.setItem(
                'agGridColumState',
                JSON.stringify(params.columnApi.getColumnState())
            )
            localStorage.setItem(
                'agGridFilterModel',
                JSON.stringify(params.api.getFilterModel())
            )
            const filterModel = that.gridApi.getFilterModel()
            // params.api.sizeColumnsToFit()
            that.search.billing_from_date = this.billing_from_date ? moment(this.billing_from_date).format('YYYY/MM/DD') : ''
            that.search.billing_to_date = this.billing_to_date ? moment(this.billing_to_date).format('YYYY/MM/DD') : ''
            const datasource = {
                getRows(params) {
                    that.search.name = params.request?.filterModel?.name?.filter
                    that.search.recalls_opened = params.request?.filterModel?.recalls_opened?.filter
                    that.search.affected_providers = params.request?.filterModel?.affected_providers?.values
                    that.search.affected_locations = params.request?.filterModel?.affected_locations?.values
                    that.search.notification_rounds = params.request?.filterModel?.notification_rounds?.filter
                    that.search.affected_locations_notifications = params.request?.filterModel?.affected_locations_notifications?.values
                    that.search.affected_locations_acknowledgements = params.request?.filterModel?.affected_locations_acknowledgements?.filter
                    that.search.affected_locations_completed = params.request?.filterModel?.affected_locations_completed?.filter
                    that.searchQuery.colId = params.request?.sortModel[0]?.colId
                    that.searchQuery.sort = params.request?.sortModel[0]?.sort
                    that.search.filterModel = that.gridApi.getFilterModel()
                    transactionBillingService.findBillingSummary({
                        ...that.searchQuery,
                        sortField: params.request?.sortModel[0]?.colId,
                        sortDirection: params.request?.sortModel[0]?.sort,
                        ...that.search,
                        filterModel
                    }).then(resp => {
                        if (!resp.error) {
                            const billingarray = []
                            for (var i = 0; i < resp.data.d.c.length; i++) {
                                var checkexist = billingarray.filter(s => s.organizationId == resp.data.d.c[i].organizationId)
                                if (checkexist.length == 0) {
                                    billingarray.push(resp.data.d.c[i])
                                }
                            }
                            that.total = resp.data.d.t
                            if(that.total == 0){
                                that.gridApi.showNoRowsOverlay()
                            }
                            else{
                                that.gridApi.hideOverlay()
                            }
                            return billingarray
                        }
                    }).then(response => {
                        params.successCallback(response)
                    })
                        .catch(error => {
                            console.error(error)
                            params.failCallback()
                        })
                }
            }
            // register datasource with the grid
            params.api.setServerSideDatasource(datasource)
        },
        viewRecall(item) {
            this.$router.push({ name: 'noti_BillingDetailView', params: { organizationId: item.organizationId, organizationName: item.name, billingFromDate: this.billing_from_date, billingToDate: this.billing_to_date, billing_filter_val: this.billing_filter_val} })
        },
        onBillingFromDateSelect(val) {
            this.billing_from_date = val
        },
        onBillingToDateSelect(val) {
            this.billing_to_date = val
        },
        onBillingFilterChange(val) {
            this.billing_filter_val = val
        }
    }
}